import { adminApiFetch } from './apiService';

export const inventoryMonitorService = {
  // 列表
  getRecords: async (params) => {
    const response = await adminApiFetch('inventory_monitors/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await adminApiFetch('inventory_monitors/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 單一資源
  get: async (id) => {
    const response = await adminApiFetch(`inventory_monitors/${id}`);
    return response.json();
  },

  // 建立
  create: async (data) => {
    const response = await adminApiFetch('inventory_monitors', {
      method: 'POST',
      body: JSON.stringify({ inventory_monitor: data })
    });
    return response.json();
  },

  // 更新
  update: async (id, data) => {
    const response = await adminApiFetch(`inventory_monitors/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ inventory_monitor: data })
    });
    return response.json();
  },

  // 刪除
  delete: async (id) => {
    const response = await adminApiFetch(`inventory_monitors/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};
